"use client";

import React from "react";
import { ArrowRight, Scale, ShoppingBag, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const expertiseData = [{
  numeral: "01",
  title: "Acquisition",
  subtitle: "Buyer Side",
  description: "Curated, legally registered brand names ready for immediate launch. Skip the 6–12 month naming process and enter the market faster with multi-class brand assets.",
  icon: ShoppingBag
}, {
  numeral: "02",
  title: "Monetization",
  subtitle: "Seller Side",
  description: "Unlock value from underused assets. We provide a structured, secure process to list, evaluate, and sell your registered trademarks to serious buyers.",
  icon: TrendingUp
}, {
  numeral: "03",
  title: "Legal Strategy",
  subtitle: "Compliance & Transfer",
  description: "End-to-end legal coordination for trademark transfer and licensing under the Trade Marks Act, 1999. We ensure absolute legal clarity and fast execution.",
  icon: Scale
}];
export default function OurCoreExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-core-expertise" className="dark bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="mb-16 md:mb-24 max-w-3xl">
            <h2 className="text-primary font-semibold tracking-wider uppercase text-sm mb-4 flex items-center gap-4">
              <span className="w-8 h-px bg-primary"></span>
              Core Services
            </h2>
            <h3 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-foreground leading-tight">
              The Golden Standard of <br className="hidden md:block" />
              <span className="font-medium">Brand Assets.</span>
            </h3>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-3 border-y border-primary/30">
            {expertiseData.map((item, i) => {
            const Icon = item.icon;
            return <div key={i} data-index={i} className="group relative p-8 md:p-12 border-b md:border-b-0 md:border-r border-primary/30 last:border-r-0 hover:bg-white/[0.02] transition-colors duration-500 flex flex-col h-full">
                  {}
                  <div className="absolute top-8 right-8 md:top-12 md:right-12 text-5xl md:text-6xl font-serif text-primary/20 group-hover:text-primary/40 transition-colors duration-500 select-none">
                    {item.numeral}
                  </div>

                  {}
                  <div className="mb-12">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-8 text-primary">
                      <Icon className="w-6 h-6" strokeWidth={1.5} />
                    </div>
                    <h4 className="text-2xl font-medium text-foreground mb-2">
                      {item.title}
                    </h4>
                    <p className="text-primary text-sm font-medium tracking-wide uppercase mb-6">
                      {item.subtitle}
                    </p>
                    <p className="text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </div>

                  {}
                  <div className="mt-auto pt-8">
                    <Link to="/HowItWorksPage" className="inline-flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary transition-colors group/link">
                      Learn more about the process
                      <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                    </Link>
                  </div>
                </div>;
          })}
          </div>

          {}
          <div className="mt-16 flex justify-center">
            <Button asChild size="lg" className="rounded-full px-8">
              <Link to="/OurCataloguePage">Explore Available Brands</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}